import type { SegmentOptionsToggleProps } from "./types";

export function SegmentOptionsToggle({ groupBySegment, onGroupBySegmentChange }: SegmentOptionsToggleProps) {
    return (
        <div className="flex items-center justify-between">
            <div>
                <span className="text-sm font-medium text-[#2d3a3f]">Group by Segment</span>
                <p className="text-[12px] text-[#5a717a]">Switch between level-based or segment-based breakdown.</p>
            </div>
            <button
                type="button"
                onClick={() => onGroupBySegmentChange(!groupBySegment)}
                className={`inline-flex h-7 w-12 items-center rounded-full transition-colors ${groupBySegment ? "bg-[#079a95]" : "bg-[#c9d1d4]"}`}
                aria-pressed={groupBySegment}
            >
                <span
                    className={`ml-0.5 inline-block h-6 w-6 transform rounded-full bg-white shadow transition ${
                        groupBySegment ? "translate-x-5" : "translate-x-0"
                    }`}
                />
            </button>
        </div>
    );
}
